document.querySelectorAll('[data-quiz-finder]').forEach((root) => {
    const intro = root.querySelector('[data-quiz-intro]');
    const stage = root.querySelector('[data-quiz-stage]');
    const results = root.querySelector('[data-quiz-results]');
    const startBtn = root.querySelector('[data-quiz-start]');
    const backBtn = root.querySelector('[data-quiz-back]');
    const nextBtn = root.querySelector('[data-quiz-next]');
    const nextLabel = root.querySelector('[data-quiz-next-label]');
    const restartBtn = root.querySelector('[data-quiz-restart]');
    const questions = Array.from(root.querySelectorAll('[data-question]'));
    const progressLabel = root.querySelector('[data-quiz-progress-label]');
    const progressDots = Array.from(root.querySelectorAll('[data-quiz-progress-dot]'));
    const grid = root.querySelector('[data-quiz-grid]');
    const emptyState = root.querySelector('[data-quiz-empty]');
    const cards = grid ? Array.from(grid.querySelectorAll('[data-quiz-product]')) : [];
    const matchMode = root.dataset.matchMode || 'any';
    const total = questions.length;

    if (total === 0 || !startBtn) {
      if (startBtn) startBtn.disabled = true;
      return;
    }

    let current = 0;
    const answers = new Array(total).fill(null);

    const showQuestion = (i) => {
      questions.forEach((q, idx) => { q.hidden = idx !== i; });
      if (progressLabel) progressLabel.textContent = (i + 1) + ' of ' + total;
      progressDots.forEach((dot, idx) => {
        if (idx < i) { dot.dataset.done = 'true'; dot.removeAttribute('data-active'); }
        else if (idx === i) { dot.dataset.active = 'true'; dot.removeAttribute('data-done'); }
        else { dot.removeAttribute('data-active'); dot.removeAttribute('data-done'); }
      });
      if (backBtn) backBtn.hidden = i === 0;
      if (nextLabel) nextLabel.textContent = i === total - 1 ? 'See matches' : 'Next';
      if (nextBtn) nextBtn.disabled = !answers[i];
    };

    const start = () => {
      intro.hidden = true;
      results.hidden = true;
      stage.hidden = false;
      current = 0;
      showQuestion(current);
    };

    const showResults = () => {
      stage.hidden = true;
      intro.hidden = true;
      results.hidden = false;
      const tokens = answers
        .filter(Boolean)
        .flatMap((v) => v.split(',').map((t) => t.trim().toLowerCase()).filter(Boolean));
      if (!cards.length) {
        if (emptyState) emptyState.hidden = false;
        return;
      }
      let visible = 0;
      cards.forEach((card) => {
        const tags = (card.dataset.tags || '').split(',').map((t) => t.trim()).filter(Boolean);
        let matches = false;
        if (!tokens.length) matches = true;
        else if (matchMode === 'all') matches = tokens.every((t) => tags.includes(t));
        else matches = tokens.some((t) => tags.includes(t));
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      if (emptyState) emptyState.hidden = visible > 0;
    };

    startBtn.addEventListener('click', start);

    questions.forEach((q, idx) => {
      q.querySelectorAll('[data-quiz-option]').forEach((input) => {
        input.addEventListener('change', () => {
          answers[idx] = input.value;
          if (nextBtn) nextBtn.disabled = false;
        });
      });
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        if (current < total - 1) { current += 1; showQuestion(current); }
        else showResults();
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', () => {
        if (results && !results.hidden) {
          results.hidden = true;
          stage.hidden = false;
          showQuestion(current);
          return;
        }
        if (current > 0) { current -= 1; showQuestion(current); }
      });
    }

    if (restartBtn) {
      restartBtn.addEventListener('click', () => {
        answers.fill(null);
        questions.forEach((q) => {
          q.querySelectorAll('[data-quiz-option]').forEach((input) => { input.checked = false; });
        });
        cards.forEach((c) => { c.hidden = false; });
        if (emptyState) emptyState.hidden = true;
        results.hidden = true;
        stage.hidden = true;
        intro.hidden = false;
      });
    }
  });
